"use client"
import "./CaseItemHero.scss"
import {useEffect} from "react";
const CaseItemHero = () => {
    useEffect(() => {
        console.log('page')
        const handleMessage = (event) => {
            // Проверяем, что сообщение пришло от YouTube
            if (event.origin !== 'https://www.youtube.com') return;
            try {
                const message = JSON.parse(event.data);
                if (message.event === 'infoDelivery' && message.info && message.info.playerState === 1) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'video_view',
                        video_name: 'Video on binary options page', // Название вашего видео
                    });
                }
            } catch (error) {
                console.error('Error parsing message data:', error);
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    const onIframeLoad = () => {
        const iframe = document.getElementById('video');
        iframe.contentWindow.postMessage(JSON.stringify({
            event: 'listening',
            id: iframe.id
        }), '*');
    };
    return (
        <section className="case">
            <div className="section__wrapper">
                <div className="case__container">
                    <p className="case__text">Case vertical</p>
                    <h1 className="case__title">Binary options</h1>
                    <ul className="data__list">
                        <li className="data__item">
                            <span>Geos</span>
                            <span>IN, ID, PH, BR</span>
                        </li>
                        <li className="data__item">
                            <span>Date</span>
                            <span>Oct 2020 - Sep 2021</span>
                        </li>
                        <li className="data__item">
                            <span>Goal</span>
                            <span>First Time Deposit</span>
                        </li>
                        <li className="data__item">
                            <span>Services</span>
                            <span>Performance, Youtube bloggers, SMM</span>
                        </li>
                    </ul>
                    <div className="case__video">
                        <div className="video-box-for-trigger"></div>
                        <iframe
                            width="560"
                            height="315"
                            id="video"
                            src="https://www.youtube.com/embed/aFENFGBKBMk?enablejsapi=1"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                            onLoad={onIframeLoad}
                        ></iframe>
                    </div>
                    <div className="case__options-box">
                        <div className="options__item">
                            <h2>Task</h2>
                            <p>To aquire new paying users to the product based on ROI.</p>
                        </div>
                        <div className="options__item">
                            <h2>Execution</h2>
                            <ul className="execution__list">
                                <li className="execution__item">
                                    <span className="execution__number">1</span>
                                    <span>{'Development of creative communication with the users (10-15 new creatives approches per week, average Facebook CTR > 2,5-3%)'}</span>
                                </li>
                                <li className="execution__item">
                                    <span className="execution__number">2</span>
                                    <span>The use of webview apps as a technique of advertising. Driving traffic through apps
                                is easier than through classical pre-landing schemes.</span>
                                </li>
                                <li className="execution__item">
                                    <span className="execution__number">3</span>
                                    <span>Traffic Channels: Facebook, Google UAC, video-networks.</span>
                                </li>
                                <li className="execution__item">
                                    <span className="execution__number">4</span>
                                    <span>Media campains in Social networks + Brand awarness and CPI/CPA campaigns with
                                influencers.</span>
                                </li>
                            </ul>
                        </div>
                        <div className="options__item options__item--result">
                            <h2>Results</h2>
                            <p>We have been aquiring the averege of 300 new unique paying users per day for 7 months
                                with
                                positive ROI. Performance campaigns were supported with brand awarness launches.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default CaseItemHero